import React from 'react';

const HeroHeader = () => (
  <div className="flex flex-col justify-center text-white text-left px-4 md:px-0">
    <h1
      className="text-4xl md:text-5xl font-bold"
      style={{ textShadow: '2px 2px 5px rgba(0, 0, 0, 0.5)' }}
    >
      Book your favorite spot today
    </h1>
  </div>
);

export default HeroHeader;
